import { signIn as nextSignIn, signOut as nextSignOut } from 'next-auth/react';

import { getAppConfig } from '@services/config';

import { homeRoute } from '@helpers/routes';

import { auth } from '@constants/auth';

const providerName = 'oauth2';

const appConfig = getAppConfig();

export function sanitizeCallbackUrl(url?: string): string | undefined {
    if (!url) return url;

    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.origin + parsedUrl.pathname;
    } catch {
        // If URL parsing fails, try to strip query params manually
        const queryIndex = url.indexOf('?');
        return queryIndex !== -1 ? url.substring(0, queryIndex) : url;
    }
}

export async function signIn(callbackUrl?: string) {
    return nextSignIn(providerName, { callbackUrl: sanitizeCallbackUrl(callbackUrl) });
}

export async function signOut() {
    return nextSignOut({ callbackUrl: homeRoute.path });
}

export function signInWithTgtId(tgtId: string, callbackUrl?: string) {
    const sanitizedUrl = sanitizeCallbackUrl(callbackUrl);
    window.location.href = `${appConfig.oauth2.tgtUrl}?authn_method=mfa-otp-bytel&tgtId=${tgtId}&service=${encodeURI(appConfig.oauth2.tgtCallbackUrl + '?callbackUrl=' + sanitizedUrl)}`;
}

export async function getServerSession() {
    return auth();
}
